<div class="my-3 my-md-5">
  <div class="container">
      <div class="page-header">
          <h1 class="page-title">
              <span *ngIf="!InsCompId">Adding Insurance Company</span>
              <span *ngIf="InsCompId">Update Insurance Company</span>
          </h1>
      </div>
      <div class="card">
          <form [formGroup]="insCompForm" (submit)="createInsComp()">

              <div class="card-body">
                  <div class="container-fluid">
                      <div class="row">
                          <div class="col-md-6 col-lg-6 right-border">
                              <div class="form-group">
                                  <label class="form-label">Name *</label>
                                  <input type="text" formControlName="name" class="form-control" />
                                  <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                      <div *ngIf="f.name.errors.required">Name is required</div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-6 col-lg-6">
                              <div class="form-group">
                                  <label class="form-label">Status *</label>
                                  <mat-select  placeholder="Status" formControlName="status">
                                      <mat-option [value]="1">Active</mat-option>
                                      <mat-option [value]="0">In-Active</mat-option>

                                  </mat-select>
                                  <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                      <div *ngIf="f.status.errors.required">Status is required</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card-footer">
                  <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                       <span *ngIf="!InsCompId">Create Insurance Company</span>
                      <span *ngIf="InsCompId">Update Insurance Company</span>
                  </button>
              </div>
          </form>
      </div>
  </div>
</div>

